var SearchBarSheetVariant;
(function (SearchBarSheetVariant) {
    SearchBarSheetVariant["Location"] = "Location";
    SearchBarSheetVariant["Dates"] = "Dates";
    SearchBarSheetVariant["Guests"] = "Guests";
    SearchBarSheetVariant["Features"] = "Features";
})(SearchBarSheetVariant || (SearchBarSheetVariant = {}));
export default SearchBarSheetVariant;
